import store from '@/store'

const countries = store.getters['app/countries']

export const BASE_FLAG_URL = 'https://hatscripts.github.io/circle-flags/flags/'
export const DEFAULT_FLAG = 'other/checkered'

export const ORDERED_LOCALES = {
  'en': 'English',
  'pt': 'Portuguese',
  'it': 'Italian',
  'de': 'German',
  'fr': 'French',
  'ru': 'Russian'
}

export const LANG_TO_LOCAL_EXCEPTIONS = {
  'en': 'gb',
  'ja': 'jp',
  'vi': 'vn',
  'da': 'dk',
  'mi': 'maori',
  'kk': 'kz',
}

export const countriesToFullNamesMap = countries.reduce((acc, country) => {
  acc[country.code.toLowerCase()] = country.title
  return acc
}, {})

export const allCountries = Object.keys(countriesToFullNamesMap).map((countryCode) => {
  const formattedValue = countryCode.toUpperCase()
  return {
    value: formattedValue,
    text: formattedValue,
    fullName: countriesToFullNamesMap[countryCode]
  }
})

export const mapperIsoLangToOurLocal = (key) => getLangToOurLocal(key, LANG_TO_LOCAL_EXCEPTIONS)

export const getLangToOurLocal = (key, mapper) => {
  return mapper[key] || key
}
export const localeToIsoPrefix = (local) => local.split('-')[0].toLowerCase().trim()
